import { createContext, useContext, type ReactNode } from 'react';

export type StarjackApp = 'Admin' | 'Backoffice' | 'B2b';

export interface StarjackConfig {
    application: StarjackApp;
}

const StarjackContext = createContext<StarjackConfig | undefined>(undefined);

export interface StarjackProviderProps {
    config: StarjackConfig;
    children: ReactNode;
}

export const StarjackProvider = ({
    config,
    children,
}: StarjackProviderProps) => {
    return (
        <StarjackContext.Provider value={config}>
            {children}
        </StarjackContext.Provider>
    );
};

export const useStarjackConfig = (): StarjackConfig => {
    const context = useContext(StarjackContext);

    if (!context) {
        throw new Error(
            'useStarjackConfig must be used within a StarjackProvider'
        );
    }

    return context;
};
